import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import type { ResourceType } from 'types/resource-types';
import { type ApiError, type ApiResponse, useAxiosInstance } from './utils';
import { addActionNameToMutationResult } from './utils/add-action-name-to-mutation-result';

export async function toggleViewPrivacyFn(
  axiosInstance: Promise<AxiosInstance>,
  { viewId }: { viewId: string },
) {
  const instance = await axiosInstance;
  return instance.put(`views/${viewId}/toggle-privacy`);
}

export function useToggleViewPrivacy() {
  const client = useQueryClient();
  const axiosInstance = useAxiosInstance();

  const mutation = useMutation<
    ApiResponse,
    ApiError,
    { viewId: string; resourceType: ResourceType }
  >({
    mutationFn: variables => toggleViewPrivacyFn(axiosInstance, variables),
    onSuccess: (_response, { resourceType }) => {
      client.invalidateQueries({
        queryKey: ['views', resourceType],
      });
    },
  });

  return addActionNameToMutationResult<
    ApiResponse,
    ApiError,
    { viewId: string; resourceType: ResourceType },
    'toggleViewPrivacy'
  >('toggleViewPrivacy', mutation);
}
